import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/app.materials';

@Component({
  selector: 'app-effective-views',
  templateUrl: './effective-views.component.html',
  styleUrls: ['./effective-views.component.scss'],
  standalone: true,
  imports: [CommonModule, MaterialModule],
})
export class EffectiveViewsComponent {
  @Input() payload: any[] = [];
  @Input() loading = false;
  @Input() error = '';

  @Output() generate = new EventEmitter<void>();
  @Output() optimize = new EventEmitter<void>();

  collapsed = false;
}
